import { ErrorHandler, request, SuccessHandler } from 'api/apiTS';
import { baseApi } from 'components/constants/Constants';
import { Product } from 'types/Products';
import { SearchDocument } from 'types/Search';

export const PutBookmark = (
  product: Product | SearchDocument,
  success: SuccessHandler,
  error: ErrorHandler
) => {
  const { company, segment } = product;
  // update here when endpoint's ready
  const options = {
    method: 'PUT',
    url: `${baseApi}/companies/${company.key}/segments/${segment}/products/${product.key}/bookmark`,
    headers: { 'Content-Type': 'application/json' }
    // data: product
  };
  request(options, success, error);
};

export const DeleteBookmark = (
  product: Product | SearchDocument,
  success: SuccessHandler,
  error: ErrorHandler
) => {
  const { company, segment } = product;
  const options = {
    method: 'DELETE',
    url: `${baseApi}/companies/${company.key}/segments/${segment}/products/${product.key}/bookmark`,
    headers: { 'Content-Type': 'application/json' }
  };
  request(options, success, error);
};
